/* SHOEBAAZAR theme runtime — Designed & developed by BLYNTL */
(function(){
  'use strict';
  var $ = function(s, r){ return (r||document).querySelector(s); };
  var $$ = function(s, r){ return [].slice.call((r||document).querySelectorAll(s)); };
  var MONEY = (window.SB_MONEY || 'Rs.{{amount}}');

  function money(v, cents){
    var n = cents ? Number(v)/100 : Number(v);
    var p = n.toFixed(2).split('.');
    var whole = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if(k === 'amount_no_decimals') return whole;
      if(k === 'amount_with_comma_separator') return whole.replace(/,/g,'.') + ',' + p[1];
      return whole + '.' + p[1];
    });
  }
  function img(src, w){ if(!src) return ''; src = src.replace(/^http:/,'https:'); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function toast(msg){ var t = $('[data-sb-toast]'); if(!t) return; t.textContent = msg; t.classList.add('is-on'); clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('is-on'); }, 2600); }

  /* panels */
  var openPanel = null;
  function open(name){
    var p = $('[data-sb-panel="' + name + '"]'); if(!p) return false;
    if(openPanel && openPanel !== p) close();
    p.classList.add('is-open'); p.setAttribute('aria-hidden','false'); document.body.classList.add('sb-lock'); openPanel = p;
    if(name === 'search'){ setTimeout(function(){ var q = $('[data-sb-q]'); if(q) q.focus(); }, 250); }
    if(name === 'cart'){ Cart.refresh(); }
    return true;
  }
  function close(){
    if(!openPanel) return;
    openPanel.classList.remove('is-open'); openPanel.setAttribute('aria-hidden','true'); openPanel = null;
    if(!$('.sb-rv.is-open')) document.body.classList.remove('sb-lock');
  }
  document.addEventListener('click', function(e){
    var o = e.target.closest('[data-sb-open]');
    if(o){ if(open(o.getAttribute('data-sb-open'))) e.preventDefault(); return; }
    if(e.target.closest('[data-sb-close]')){ e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ close(); Reels.close(); } });

  /* announcement */
  $$('[data-sb-ann]').forEach(function(a){
    var m = $$('.sb-ann__msg', a); if(m.length < 2) return; var i = 0;
    setInterval(function(){
      var cur = m[i]; i = (i + 1) % m.length; var nx = m[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      nx.classList.remove('is-out'); nx.classList.add('is-on');
      setTimeout(function(){ cur.classList.remove('is-out'); }, 600);
    }, 4000);
  });

  /* header */
  var hdr = $('[data-sb-header]');
  if(hdr){
    var last = 0, ticking = false;
    var onScroll = function(){
      var y = window.scrollY || 0;
      hdr.classList.toggle('is-solid', y > 30);
      if(!openPanel) hdr.classList.toggle('is-hidden', y > 420 && y > last + 4);
      if(y < last - 4 || y < 420) hdr.classList.remove('is-hidden');
      last = y; ticking = false;
    };
    window.addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(onScroll); } }, {passive:true});
    onScroll();
  }

  /* predictive search */
  var q = $('[data-sb-q]'), res = $('[data-sb-results]');
  if(q && res){
    var t;
    q.addEventListener('input', function(){
      clearTimeout(t);
      var v = q.value.trim();
      if(v.length < 2){ res.innerHTML = ''; return; }
      t = setTimeout(function(){
        fetch('/search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function(r){ return r.json(); })
          .then(function(j){
            var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            if(!ps.length){ res.innerHTML = '<p class="sb-sub">No results for "' + esc(v) + '".</p>'; return; }
            res.innerHTML = '<div class="sb-grid">' + ps.map(function(p){
              return '<a class="sb-card" href="' + p.url + '"><div class="sb-card__media">' + (p.image ? '<img loading="lazy" src="' + img(p.image, 400) + '" alt="' + esc(p.title) + '">' : '') + (p.available ? '' : '<span class="sb-badge sb-badge--out">Sold out</span>') + '</div><div class="sb-card__body"><h3 class="sb-card__title">' + esc(p.title) + '</h3><div class="sb-card__price">' + money(p.price) + '</div></div></a>';
            }).join('') + '</div><p style="text-align:center;margin-top:24px"><a class="sb-link" href="/search?type=product&q=' + encodeURIComponent(v) + '">See all results</a></p>';
          }).catch(function(){});
      }, 220);
    });
  }

  /* cart */
  var Cart = {
    setCount: function(n){
      $$('[data-sb-count]').forEach(function(c){ c.textContent = n; c.hidden = !n; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); });
      $$('[data-sb-count-t]').forEach(function(c){ c.textContent = n ? '(' + n + ')' : ''; });
    },
    render: function(cart){
      var box = $('[data-sb-cart-items]'); if(!box) return;
      Cart.setCount(cart.item_count);
      var sub = $('[data-sb-subtotal]'); if(sub) sub.textContent = money(cart.total_price, true);
      var foot = $('.sb-cart__foot'); if(foot) foot.style.display = cart.item_count ? '' : 'none';
      if(!cart.item_count){
        box.innerHTML = '<div class="sb-cart__empty"><p class="sb-h sb-h--sm">Your bag is empty</p><p class="sb-sub" style="margin:10px auto 22px">Find your next favourite pair.</p><a class="sb-btn" href="/collections/all">Start shopping</a></div>';
        return;
      }
      box.innerHTML = cart.items.map(function(it, i){
        var opts = (it.options_with_values || []).filter(function(o){ return o.value !== 'Default Title'; }).map(function(o){ return (/size/i.test(o.name) ? 'EU ' : o.name + ': ') + o.value; }).join(' · ');
        return '<div class="sb-ci" data-line="' + (i+1) + '">' +
          '<a class="sb-ci__img" href="' + it.url + '">' + (it.image ? '<img src="' + img(it.image, 200) + '" alt="">' : '') + '</a>' +
          '<div><p class="sb-ci__t"><a href="' + it.url + '">' + esc(it.product_title) + '</a></p>' + (opts ? '<p class="sb-ci__v">' + esc(opts) + '</p>' : '') +
          '<div class="sb-ci__row"><div class="sb-qty"><button type="button" data-q="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Increase">+</button></div><span class="sb-ci__p">' + money(it.final_line_price, true) + '</span></div>' +
          '<button type="button" class="sb-ci__rm" data-q="0">Remove</button></div></div>';
      }).join('');
    },
    refresh: function(){ return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(c){ Cart.render(c); return c; }); },
    change: function(line, qty){
      return fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({line: line, quantity: qty})})
        .then(function(r){ return r.json(); }).then(function(c){ if(c.status && c.description){ toast(c.description); return Cart.refresh(); } Cart.render(c); });
    },
    add: function(id, qty){
      return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id: id, quantity: qty || 1}]})})
        .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
        .then(function(){ return Cart.refresh(); })
        .then(function(){ if(!open('cart')) toast('Added to bag'); })
        .catch(function(err){ toast((err && (err.description || err.message)) || 'Could not add to bag'); throw err; });
    }
  };
  window.SBCart = Cart;
  document.addEventListener('click', function(e){
    var b = e.target.closest('.sb-ci [data-q]'); if(!b) return;
    var row = b.closest('.sb-ci'); var line = +row.getAttribute('data-line');
    var cur = +$('.sb-qty span', row).textContent; var d = +b.getAttribute('data-q');
    row.style.opacity = '.5';
    Cart.change(line, d === 0 ? 0 : Math.max(0, cur + d));
  });

  /* rails */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-sb-rail-prev],[data-sb-rail-next]'); if(!b) return;
    var sec = b.closest('section') || document; var rail = $('[data-sb-rail]', sec) || $('.sb-rail', sec); if(!rail) return;
    rail.scrollBy({left: (b.hasAttribute('data-sb-rail-next') ? 1 : -1) * rail.clientWidth * 0.85, behavior:'smooth'});
  });

  /* product page */
  $$('[data-sb-product]').forEach(function(root){
    var variants = JSON.parse(($('[data-sb-variants]', root) || {}).textContent || '[]');
    var form = $('[data-sb-atc-form]', root); if(!form) return;
    var vid = $('[data-sb-vid]', form), add = $('[data-sb-add]', form), addT = $('[data-sb-add-t]', form);
    var priceBox = $('[data-sb-price]', root), stock = $('[data-sb-stock]', root);
    var sets = $$('[data-sb-opt]', root);
    var sizeIdx = -1;
    sets.forEach(function(fs, i){ if(/size/i.test($('legend', fs).textContent)) sizeIdx = i; });
    var needPick = sizeIdx > -1 && location.search.indexOf('variant=') < 0 && $$('input', sets[sizeIdx]).length > 1;
    if(needPick){ $$('input', sets[sizeIdx]).forEach(function(r){ r.checked = false; }); }

    function selected(){ return sets.map(function(fs){ var c = $('input:checked', fs); return c ? c.value : null; }); }
    function find(sel){ return variants.find(function(v){ return v.options.every(function(o, i){ return sel[i] === o; }); }); }
    function markAvail(sel){
      sets.forEach(function(fs, i){
        $$('.sb-sz', fs).forEach(function(l){
          var val = $('input', l).value;
          var ok = variants.some(function(v){ return v.available && v.options.every(function(o, k){ return k === i ? o === val : (sel[k] == null || sel[k] === o); }); });
          l.classList.toggle('is-out', !ok);
        });
      });
    }
    var sticky = $('[data-sb-sticky]', root), main = $('[data-sb-main-atc]', root);
    var sBtn = sticky && $('[data-sb-sticky-btn]', sticky), sP = sticky && $('[data-sb-sticky-p]', sticky);
    function syncSticky(v){
      if(!sBtn) return;
      if(!v){ sBtn.disabled = false; sBtn.textContent = add.dataset.pick ? 'Select size' : 'Unavailable'; return; }
      sBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
      sBtn.disabled = !v.available; if(sP) sP.textContent = money(v.price, true);
    }
    function update(push){
      var sel = selected();
      markAvail(sel);
      sets.forEach(function(fs, i){ var b = $('[data-sb-opt-val]', fs); if(b) b.textContent = sel[i] ? ((i === sizeIdx ? 'EU ' : '') + sel[i]) : 'Select'; });
      if(sel.some(function(x){ return x == null; })){
        add.disabled = false; addT.textContent = 'Select your size'; add.dataset.pick = '1';
        stock.textContent = ''; stock.className = 'sb-pdp__stock';
        syncSticky(null); return;
      }
      delete add.dataset.pick;
      var v = find(sel);
      if(!v){ add.disabled = true; addT.textContent = 'Unavailable'; syncSticky(null); return; }
      vid.value = v.id;
      add.disabled = !v.available;
      addT.textContent = v.available ? 'Add to bag' : 'Sold out in this size';
      stock.textContent = v.available ? 'In stock — ready to ship' : 'This size is sold out — try another';
      stock.className = 'sb-pdp__stock ' + (v.available ? 'is-ok' : 'is-low');
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      priceBox.innerHTML = '<span class="sb-pdp__now' + (sale ? ' is-sale' : '') + '">' + money(v.price, true) + '</span>' + (sale ? '<s>' + money(v.compare_at_price, true) + '</s><span class="sb-pdp__save">Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%</span>' : '');
      if(push){ try{ var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }catch(e){} }
      if(v.featured_media && push){ var s = $('[data-media-id="' + v.featured_media.id + '"]', root); if(s && window.innerWidth < 990){ s.parentNode.scrollTo({left: s.offsetLeft, behavior:'smooth'}); } }
      var wa = $('[data-sb-wa]', root);
      if(wa){ wa.href = wa.getAttribute('data-base') + encodeURIComponent('Hi Shoebaazar! I want to order: ' + wa.getAttribute('data-title') + (sizeIdx > -1 ? ' — Size EU ' + sel[sizeIdx] : '') + ' — ' + wa.getAttribute('data-link') + '?variant=' + v.id); }
      syncSticky(v);
    }
    sets.forEach(function(fs){ fs.addEventListener('change', function(){ update(true); }); });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(add.dataset.pick){ var f = sets[sizeIdx]; f.classList.remove('sb-shake'); void f.offsetWidth; f.classList.add('sb-shake'); f.scrollIntoView({behavior:'smooth', block:'center'}); toast('Please select your size'); return; }
      if(add.disabled) return;
      add.classList.add('is-loading');
      Cart.add(+vid.value, 1).catch(function(){}).then(function(){ add.classList.remove('is-loading'); });
    });

    var gal = $('[data-sb-gal]', root), gi = $('[data-sb-gal-i]', root), dots = $$('.sb-gal__dots i', root);
    if(gal && gi){
      gal.addEventListener('scroll', function(){
        var i = Math.round(gal.scrollLeft / gal.clientWidth);
        gi.textContent = i + 1; dots.forEach(function(d, k){ d.classList.toggle('is-on', k === i); });
      }, {passive:true});
    }

    if(sticky && main && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        var e = es[0]; var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on));
      }).observe(main);
      sBtn.addEventListener('click', function(){
        if(add.dataset.pick){ sets[sizeIdx].scrollIntoView({behavior:'smooth', block:'center'}); return; }
        if(form.requestSubmit) form.requestSubmit(); else add.click();
      });
    }
    update(false);
  });

  /* collection */
  $$('[data-sb-col]').forEach(function(col){
    var sort = $('[data-sb-sort]', col);
    if(sort){ sort.addEventListener('change', function(){ var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u; }); }
    col.addEventListener('click', function(e){
      var m = e.target.closest('[data-sb-more]'); if(!m) return;
      e.preventDefault(); m.classList.add('is-loading');
      fetch(m.href).then(function(r){ return r.text(); }).then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-sb-col-grid]', col), ng = $('[data-sb-col-grid]', doc);
        if(ng){ [].slice.call(ng.children).forEach(function(c){ grid.appendChild(c); }); }
        var nm = $('[data-sb-more]', doc), shown = $('[data-sb-shown]', col), ns = $('[data-sb-shown]', doc);
        if(nm){ m.href = nm.href; m.classList.remove('is-loading'); if(shown && ns) shown.textContent = ns.textContent; }
        else { var box = m.closest('.sb-col__more'); if(box) box.remove(); }
      }).catch(function(){ location.href = m.href; });
    });
    var tg = $('[data-sb-size-toggle]', col), panel = $('[data-sb-size-panel]', col);
    if(tg && panel){
      tg.addEventListener('click', function(){ var o = panel.hidden; panel.hidden = !o; tg.setAttribute('aria-expanded', String(o)); if(!o){ col.classList.remove('is-sizing'); } });
    }
    col.addEventListener('sb:size', function(){ col.classList.add('is-sizing'); if(panel && panel.hidden){ panel.hidden = false; if(tg) tg.setAttribute('aria-expanded','true'); } });
    col.addEventListener('sb:size-clear', function(){ col.classList.remove('is-sizing'); });
  });

  /* reels */
  var Reels = { close: function(){} };
  $$('[data-sb-reels]').forEach(function(sec){
    var vids = $$('.sb-reel__v', sec);
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          var v = e.target;
          if(e.isIntersecting){ if(!v.getAttribute('src') && v.dataset.src){ v.src = v.dataset.src; } var p = v.play(); if(p && p.catch) p.catch(function(){}); }
          else { v.pause(); }
        });
      }, {threshold:.55});
      vids.forEach(function(v){ io.observe(v); });
    }
    var rv = $('[data-sb-rv]', sec), feed = $('[data-sb-rv-feed]', sec), sound = false, vio;
    if(!rv) return;
    document.body.appendChild(rv);
    var reels = $$('.sb-reel', sec).map(function(r){
      var v = $('.sb-reel__v', r), pj = $('[data-sb-reel-p]', r);
      return {src: v.dataset.src, poster: v.getAttribute('poster'), p: pj ? JSON.parse(pj.textContent) : null};
    });
    function sheet(p){
      if(!p) return '';
      var si = (p.options || []).findIndex(function(o){ return /size/i.test(o); });
      var av = p.variants.filter(function(v){ return v.available; });
      var btns = av.map(function(v){ return '<button type="button" data-v="' + v.id + '">' + esc(si > -1 ? v.options[si] : v.title) + '</button>'; }).join('');
      var single = av.length === 1 && p.variants.length === 1;
      return '<div class="sb-rv__sheet"><div class="sb-rv__top">' + (p.img ? '<img src="' + p.img + '" alt="">' : '') + '<div style="flex:1;min-width:0"><b>' + esc(p.title) + '</b><em>' + esc(p.price) + '</em></div><a href="' + p.url + '">View</a></div>' +
        (av.length ? (single ? '' : '<div class="sb-rv__sizes">' + btns + '</div>') + '<button type="button" class="sb-btn sb-btn--block" data-rv-add' + (single ? ' data-v="' + av[0].id + '"' : '') + '><span class="sb-spin"></span><span class="sb-btn__t">' + (single ? 'Add to bag' : 'Select size') + '</span></button>' : '<a class="sb-btn sb-btn--block sb-btn--outline" href="' + p.url + '">Sold out · view</a>') + '</div>';
    }
    function play(item){
      $$('video', feed).forEach(function(v){ if(v !== item){ v.pause(); } });
      if(!item) return; item.muted = !sound; var pr = item.play(); if(pr && pr.catch) pr.catch(function(){});
    }
    function openAt(i){
      feed.innerHTML = reels.map(function(r){ return '<div class="sb-rv__item"><video src="' + r.src + '" poster="' + (r.poster||'') + '" loop playsinline muted preload="metadata"></video>' + sheet(r.p) + '</div>'; }).join('');
      rv.classList.add('is-open'); rv.setAttribute('aria-hidden','false'); document.body.classList.add('sb-lock');
      var items = $$('.sb-rv__item', feed);
      feed.scrollTop = items[i].offsetTop;
      if(vio) vio.disconnect();
      vio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) play($('video', e.target)); }); }, {root: feed, threshold:.6});
      items.forEach(function(it){ vio.observe(it); });
      play($('video', items[i]));
    }
    Reels.close = function(){ if(!rv.classList.contains('is-open')) return; $$('video', feed).forEach(function(v){ v.pause(); }); rv.classList.remove('is-open'); rv.setAttribute('aria-hidden','true'); feed.innerHTML = ''; if(!openPanel) document.body.classList.remove('sb-lock'); };
    sec.addEventListener('click', function(e){ var o = e.target.closest('[data-sb-reel-open]'); if(o){ openAt(+o.getAttribute('data-sb-reel-open')); } });
    rv.addEventListener('click', function(e){
      if(e.target.closest('[data-sb-rv-close]')){ Reels.close(); return; }
      if(e.target.closest('[data-sb-rv-sound]')){ sound = !sound; rv.classList.toggle('is-sound', sound); $$('video', feed).forEach(function(v){ v.muted = !sound; }); return; }
      var sb = e.target.closest('.sb-rv__sizes button');
      if(sb){ var sh = sb.closest('.sb-rv__sheet'); $$('.sb-rv__sizes button', sh).forEach(function(x){ x.classList.remove('is-on'); }); sb.classList.add('is-on'); var a = $('[data-rv-add]', sh); a.setAttribute('data-v', sb.getAttribute('data-v')); $('.sb-btn__t', a).textContent = 'Add to bag'; return; }
      var ad = e.target.closest('[data-rv-add]');
      if(ad){
        var id = ad.getAttribute('data-v'); if(!id){ toast('Please select your size'); return; }
        ad.classList.add('is-loading');
        fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id:+id, quantity:1}]})})
          .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; }); })
          .then(function(){ return Cart.refresh(); }).then(function(){ toast('Added to bag'); $('.sb-btn__t', ad).textContent = 'Added ✓'; })
          .catch(function(err){ toast((err && err.description) || 'Could not add'); })
          .then(function(){ ad.classList.remove('is-loading'); });
      }
    });
  });

  /* reveal */
  var els = $$('.sb-reveal:not(.is-in)');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('is-in'); }); }
  else {
    var rio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); rio.unobserve(e.target); } }); }, {rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ rio.observe(e); });
  }
})();